export enum MachineServiceLogsRoutes {
  GetAll = 'get-all',
  GetLatest = 'get-latest',
  CreateOne = 'create-one',
  DeleteOne = 'delete-one',
  UpdateOne = 'update-one',
}
